<template>
  <div>
  <div v-if="publishedDiscussions.length > 0 && discussions">
      <div v-for="(item, index) in publishedDiscussions" :key="index" :ref="'discussion-' + item.shortId">
        <discussion
          @publish="publishDiscussion"
          @editComment="editDiscussion"
          @subscribe="subscribe"
          @clicked="postComments"
          @notify="showSnackbar"
          :uuid="item._id"
          :shortId="item.shortId"
          :item="item._source"
          :keywords="keywords"
          :subscribed="item._source.subscribed"
          :unsubscribed="item._source.unsubscribed"
          :chronologicalRange="chronologicalRange"
          :iconographyList="iconographyList"
          :cavesList="cavesList"
          :prsList="prsList"
          :isFirst="true"
          :intro="intro"
          :biblios="biblios"
        ></discussion>
      </div>

    </div>
        <v-snackbar
      v-model="snackbar"
      timeout="2000"
      top
      right
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import {putComments} from '@/services/repository'
import discussion from '@/components/discussion'

export default {
  components: {
    discussion
  },
  name: 'foruminf',
  props: {
    intro:{
      type: Object,

      default: function(){
        return {}
      }
    },
    discussions: null,
    newPosts: {
      type: Boolean,
      default: true
    },
    heading: {
      type: String,
      default: "Discussion"
    },
    biblios:{
      type: Array,
      default: function(){
        return []
      }
    },
    chronologicalRange:{
      type: Array,
      default: function(){
        return []
      }
    },
    keywords:{
      type: Array,
      default: function(){
        return []
      }
    },
    cavesList:{
      type: Array,
      default: function(){
        return []
      }
    },
    iconographyList:{
      type: Array,
      default: function(){
        return []
      }
    },
    prsList:{
      type: Array,
      default: function(){
        return []
      }
    },
  },
  data () {
    return {
      snackbar: false,
      snackbarText: ''
    }
  },
  computed:{
    publishedDiscussions(){
      this.$log.debug("publishedDiscussions", this.discussions, this.$store.state.user.accessLevel);
      if (this.$store.state.user.accessLevel === 4){

        return this.discussions
      } else {
        let published = []
        if (this.discussions){
          for (let discussion of this.discussions){
            if (discussion._source.published){
              published.push(discussion)
            } else if (this.$store.state.user.userID === discussion._source.userID) {
              published.push(discussion)
            }
          }

        }

        this.$log.debug("returning publishedDiscussions", published);
        return published
      }
    }
  },
  methods: {


    showSnackbar(text) {
      this.$log.debug("showSnackbar", text);
      this.snackbarText = text
      this.snackbar = true
    },
    publishDiscussion(value){
      this.$log.debug("this.publishedDiscussion", value);
      let newComments = []
      for (let discussion of this.discussions){
        if (discussion._id === value){
          discussion._source["published"] = true
          putComments(discussion._source, value, true, this.$store.state.user.sessionID, discussion.body)
          break
        }
      }
      this.$log.debug(newComments);
      this.$emit('clicked', newComments)
    },

    scrollToDiscussion(id) {
      this.$log.debug("scrollToDiscussion", id);
      this.$nextTick(() => {
        const ref = this.$refs['discussion-' + id]

        if (ref && ref[0]) {
          ref[0].scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      })
    },
    editDiscussion(value){
      this.$log.debug("editDiscussion", value);
      this.$log.debug("Discussions", this.discussions);
      let uuid = value.uuid
      delete value.uuid
      this.$log.debug("this.$store.state.user.sessionID", this.$store.state.user.sessionID);
      putComments(value, uuid, false, this.$store.state.user.sessionID)
      for (let discussion of this.discussions){
        if (discussion._id === uuid){
          this.$log.debug("discussion", discussion);
          discussion = value
        }
      }
    },
    subscribe(data){
      this.$log.debug("subscribe initiated:", data);
      var filtered = []
      var parentDiscussion = this.discussions.find(element => element._id === data.uuid)
      this.$log.debug("Discussion",  this.discussions);
      this.$log.debug("parentDiscussion", parentDiscussion);
      var _self = this
      if (data.isSubscribed){
        filtered = parentDiscussion._source.unsubscribed.filter(function(value, index, arr){
          return value !== _self.$store.state.user.userID;
        });
        parentDiscussion._source.unsubscribed = filtered
        filtered = parentDiscussion._source.subscribed.filter(function(value, index, arr){
          return value !== _self.$store.state.user.userID;
        });
        parentDiscussion._source.subscribed = filtered
        parentDiscussion._source.subscribed.push(this.$store.state.user.userID)
      } else {
        filtered = parentDiscussion._source.unsubscribed.filter(function(value, index, arr){
          return value !== _self.$store.state.user.userID;
        });
        parentDiscussion._source.unsubscribed = filtered
        filtered = parentDiscussion._source.subscribed.filter(function(value, index, arr){
          return value !== _self.$store.state.user.userID;
        });
        parentDiscussion._source.subscribed = filtered
        parentDiscussion._source.unsubscribed.push(this.$store.state.user.userID)
      }
      this.$log.debug("discussions", this.discussions);
      putComments(parentDiscussion._source, parentDiscussion._id, false, this.$store.state.user.sessionID)
    },
    getComments(){
      this.$emit("getComments", '')
    },
    postComments(comments){
      this.$log.debug("post comment in forum:", comments);
      var parentDiscussion = this.discussions.find(element => element._id === comments.comment[0].parentUuid)
      parentDiscussion._source.comments = comments.comment
      parentDiscussion._source.latestUpdate = Date.now();
      this.$log.debug("PrarenDiscussion", parentDiscussion);
      if (!parentDiscussion._source.unsubscribed.includes(this.$store.state.user.userID)){
        if (!parentDiscussion._source.subscribed.includes(this.$store.state.user.userID)){
          parentDiscussion._source.subscribed.push(this.$store.state.user.userID)
        }
      }
      this.$log.debug(parentDiscussion);
      putComments(parentDiscussion._source, comments.comment[0].parentUuid, comments.sendMail, this.$store.state.user.sessionID, comments.text)
    }
  },
  watch:{
    discussions(newVal, oldVal){
      this.$log.debug("published discussions", this.publishedDiscussions, this.discussions );
      const id = this.$route.query.discussion
      if (id) {
        this.scrollToDiscussion(id)
      }
    }

  },
  mounted:function () {
    this.$log.debug("published discussions", this.publishedDiscussions, this.discussions );
    const id = this.$route.query.discussion
    if (id) {
      this.scrollToDiscussion(id)
    }
  },
}

</script>

<style></style>
